export const PROJECTS_PREFIX         = 'PROJECTS_';

export const pageSize = 12;
